/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_2_ProblemInputs */

const et_portfolio_project_2_problem = /** @type {(inputs: Portfolio_Project_2_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eelmise arendaja poolt hüljatud projekt – puudus toimiv veebileht, suund ja päringute voog.`)
};

const en_portfolio_project_2_problem = /** @type {(inputs: Portfolio_Project_2_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project abandoned by previous developer - no working website, no direction, no lead flow.`)
};

/**
* | output |
* | --- |
* | "Project abandoned by previous developer - no working website, no direction, no lead flow." |
*
* @param {Portfolio_Project_2_ProblemInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_2_problem = /** @type {((inputs?: Portfolio_Project_2_ProblemInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_2_ProblemInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_2_problem(inputs)
	return en_portfolio_project_2_problem(inputs)
});